<template>
  <template v-if="!isFAL">
    <InputButton v-if="hasEmail"
                 :block="true"
                 :chevron="true"
                 styleType="contact"
                 @click="$emit('contactFormSelect', { form: 'email' })"
    >Email Agency
    </InputButton>
    <InputButton v-if="hasTelephone"
                 :block="true"
                 :chevron="true"
                 styleType="contact"
                 @click="$emit('contactFormSelect', { form: 'telfax' })"
    >Display Phone Number
    </InputButton>
    <InputButton v-if="hasWebsite"
                 :block="true"
                 :chevron="true"
                 styleType="contact"
                 @click="$emit('contactFormSelect', { form: 'website' })"
    >Visit Website
    </InputButton>
    <!-- note that v-if has an "isFAL" here -->
    <InputButton v-if="!isPersonalPage"
                 :block="true"
                 class="hidden py-2 text-center text-base font-normal text-blue-50 sm:block"
                 styleType="contact"
                 @click="$emit('moreInfoSelect')"
    >More Info
    </InputButton>
  </template>
  <!-- FREE AGENCIES ONLY -->
  <template v-else>
    <InputButton v-if="hasTelephone"
                 :block="true"
                 :chevron="true"
                 styleType="contact"
                 @click="$emit('contactFormSelect', { form: 'telfax' })"
    >Display Phone Number
    </InputButton>
    <InputButton v-if="hasWebsite"
                 :block="true"
                 :chevron="true"
                 styleType="contact"
                 @click="$emit('contactFormSelect', { form: 'website' })"
    >Visit Website
    </InputButton>
  </template>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'AgencyAdvertContactOptionsNeither',
  components: {InputButton},
  props: {
    agency: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  emits: ['contactFormSelect', 'moreInfoSelect'],
  computed: {
    ...mapGetters('pagetext', ['isPersonalPage']),
    ...mapState('contact', ['requestorType']),
    isFAL() {
        return (this.agency.FAL == 'Y' || this.agency.FAL === true) ? true : false;
    },
    hasEmail() {
      if (!this.requestorType) return true;

      const emailMapping = {
        emp: this.agency.EmpEmail,
        cnd: this.agency.CandEmail,
      };

      return (emailMapping[this.requestorType] || 0) > 0;
    },
    hasTelephone() {
      if (!this.requestorType) return true;

      const phoneMapping = {
        emp: this.agency.EmpTelFax,
        cnd: this.agency.CandTelFax,
      };

      return (phoneMapping[this.requestorType] || 0) > 0;
    },
    hasWebsite() {
      if (!this.requestorType) return true;

      const websiteMapping = {
        emp: this.agency.EmpWebsite,
        cnd: this.agency.CandWebsite,
      };

      return (websiteMapping[this.requestorType] || 0) > 0;
    },

  },

};
</script>
